type Props = {
  label: string;
  costSeconds: number;
  paid: boolean;
  disabled?: boolean;
  onClick: () => void;
};

export function HintButton({ label, costSeconds, paid, disabled = false, onClick }: Props) {
  return (
    <button
      type="button"
      className="grid-action"
      disabled={disabled}
      onClick={onClick}
      aria-label={`${label}, ${paid ? 'free' : `costs ${costSeconds} seconds`}`}
    >
      {label} <span>{paid ? '(free)' : `(+${costSeconds}s)`}</span>
    </button>
  );
}
